import { CheckCircle2 } from "lucide-react";

const Logo = ({ className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <span
      className="inline-flex items-center justify-center w-8 h-8 rounded-xl"
      style={{ background: "var(--sp-primary)" }}
    >
      <CheckCircle2 className="w-5 h-5 text-[#0a2914]" strokeWidth={2.5} />
    </span>
    <span className="font-display font-bold text-xl tracking-tight text-[#122118]">
      Plan Étude
    </span>
  </div>
);

export default Logo;
